export default __webpack_public_path__ + "static/media/2-2-1.3197c841.jpg";